import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Cookies from 'js-cookie';

import _ from 'lodash';
// import { defaultClient } from '../main';

Vue.use(Vuex);

const { findRestrictions } = require('../utils/permissions');
const { getFacets } = require('../utils/content');

function initialState () {
  return {
    cloudinaryConfig: {},
    currentUser: null,
    version: null,
    versions: [],
    rawContentTypes: {},
    allContentTypes: [],
    loggedTime: null,
    keepAlive: true,
    reloadSearchBar: true,
    include: [],
    hasChanges: false,
    environment: null,
    workflows: null,
    workspaces: null,
    workspace: null,
    locale: null,
    allWorkspaces: null,
    rules: {
      // workspacesSelected: [],
      // contextsList: null, // CONTEXT ACCORDINGLY WORKSPACE
      contextsSelect: [] // CONTEXT SELECTED
    },
    references: null,

    /*
    accountNS: null,
    currentCT: null,

    goBack: false,

    */
    loaded: false,
    googleAuthCode: null,
    search: {
      facets: {},
      filters: [],
      query: '',
      start: 0
    },
    searchFields: ['wtitle', 'uuid*', 'url*', 'code', 'iresaPackageCode']
  };
}

const store = new Vuex.Store({
  plugins: [createPersistedState({
    paths: [
      'cloudinaryConfig', 'currentUser', 'version', 'versions', 'workflows', 'workspaces', 'workspace', 'locale', 'allWorkspaces',
      'rawContentTypes', 'allContentTypes', 'loggedTime', 'keepAlive', 'googleAuthCode',
      'include', 'ts'
    ]
  })],
  state: initialState,
  mutations: {
    addFilter (state, data) {
      state.search.start = 0;
      state.search.filters.push(data);
    },
    replaceFilter (state, data) {
      const index = state.search.filters.findIndex(filter => filter.field === data.field);
      Vue.set(state.search.filters, index, data);
      state.search.start = 0;
    },
    removeFilter (state, data) {
      const index = state.search.filters.findIndex(filter => filter.id === data.id);
      if (index !== -1) state.search.filters.splice(index, 1);
    },
    changeFacetQuery (state, facetData) {
      Vue.set(state.search.facets, facetData.attribute, facetData.query);
    },
    clearFilters (state) {
      state.search.filters = [];
      state.search.query = '';
      state.search.start = 0;
    },
    setSearchStart (state, value) {
      state.search.start = value;
    },
    setReferences (state, data) {
      Vue.set(state, 'references', data);
    },

    setContextsSelect (state, value) {
      state.rules.contextsSelect = value || [];
    },
    // setContextsList (state, value) {
    //   state.rules.contextsList = value;
    // },
    // updateWorkspacesSelected (state, newWorkspaces) {
    //   state.rules.workspacesSelected = newWorkspaces;
    // },
    // updateContextsList (state, newContextList) {
    //   // IF newContexts is one , update the select
    //   if (newContextList.length === 1) {
    //     state.rules.contextsSelect = newContextList.map(({ context }) => context);
    //   } else {
    //     if (state.rules.contextsList && state.rules.contextsList.length === 1 && state.rules.contextsSelect.length) {
    //       state.rules.contextsSelect = [];
    //     }
    //     // FILTER THE CONTEXTS WICH IS SELECTED AND NEW CONTEXT
    //     state.rules.contextsSelect = newContextList.filter(c => state.rules.contextsSelect.includes(c.context)).map(({ context }) => context);
    //   }
    //   // UPDATE CONTEXTS LIST
    //   state.rules.contextsList = newContextList;
    // },
    setCloudinaryConfig (state, data) {
      if (data.cloudinaryConnector && data.cloudinarySignature) {
        const config = {
          cloud_name: data.cloudinaryConnector.cloudName,
          api_key: data.cloudinaryConnector.apiKey,
          multiple: false,
          signature: data.cloudinarySignature.signature,
          username: data.cloudinarySignature.username,
          timestamp: data.cloudinarySignature.time
        };

        Vue.set(state, 'cloudinaryConfig', config);
      }
    },
    setCurrentUser (state, data) {
      Vue.set(state, 'currentUser', data);
    },
    setVersion (state, newVersion) {
      Vue.set(state, 'version', newVersion);
    },
    setRawContentTypes (state, data) {
      Vue.set(state, 'rawContentTypes', data);
    },
    setAllContentTypes (state, data) {
      Vue.set(state, 'allContentTypes', data);
    },
    setLoggedTime (state, data) {
      Vue.set(state, 'loggedTime', data);
    },
    setVersions (state, versions) {
      // We don't want older versions
      Vue.set(state, 'versions', versions);
    },
    setWorkflows (state, workflows) {
      Vue.set(state, 'workflows', workflows);
    },
    setWorkspaces (state, workspaces) {
      Vue.set(state, 'workspaces', workspaces);
    },
    setAllWorkspaces (state, workspaces) {
      Vue.set(state, 'allWorkspaces', workspaces);
    },
    setWorkspace (state, workspace) {
      if (!workspace.settings?.languages) {
        Vue.set(state, 'locale', null);
      }
      Vue.set(state, 'workspace', workspace);
    },
    setLocale (state, locale) {
      Vue.set(state, 'locale', locale);
    },
    setInclude (state, include) {
      Vue.set(state, 'include', include);
    },
    setKeepAlive (state, value) {
      Vue.set(state, 'keepAlive', value);
    },
    setReloadSearchBar (state, value) {
      Vue.set(state, 'reloadSearchBar', value);
    },
    setHasChanges (state, value) {
      Vue.set(state, 'hasChanges', value);
    },
    setEnvironment (state, value) {
      Vue.set(state, 'environment', value);
    },
    /*
    setAccountNS (accountNS) {
      store.accountNS = accountNS
      saveState()
    } */
    setLoaded (state, value) {
      Vue.set(state, 'loaded', value);
    },
    setTimestamp (state, value) {
      Vue.set(state, 'ts', value);
    },
    setGoogleAuthCode (state, value) {
      Vue.set(state, 'googleAuthCode', value);
    },
    updateWorkspacesSelected: (state, newWorkspaces) => {
      state.rules.workspacesSelected = newWorkspaces;
    }
    // reset (state) {
    //   // acquire initial state
    //   let resetedState = initialState();

    //   resetedState.currentProject = state.currentProject;
    //   resetedState.enviroments = state.enviroments;

    //   Object.assign(state, resetedState)
    // },
  },
  actions: {
    // CLEAR CONTEXTS BOTH CONTEXTS LIST
    // clearContextsList ({ commit }) {
    //   commit('setContextsList', []);
    //   commit('setContextsSelect', []);
    // }
  },
  getters: {
    searchSelectedContentType: state => {
      const wtypeSelected = state.search.filters.find(f => f.field === 'wtype');
      if (!wtypeSelected) {
        return null;
      }

      const foundContentType = Object.values(state.rawContentTypes).find(ct => ct.configs && ct.configs.wtype === wtypeSelected.value);

      if (!foundContentType) {
        return null;
      }

      return {
        wtype: wtypeSelected,
        ...foundContentType
      };
    },
    searchFilterFacetting: state => {
      // Wtype is always included as facetting
      const facets = { wtype: [{ type: 'value', name: 'Content-Types', size: 1000 }] };

      // From the filters, try to find in the filter all any wtype filter
      let wtypeSelected = null;

      if (state.search.filters && state.search.filters.length) {
        wtypeSelected = state.search.filters.find(f => f.field === 'wtype').value;
      }
      // wtypeSelected = 'product';
      if (!wtypeSelected) {
        return facets;
      }

      const foundContentType = Object.values(state.rawContentTypes).find(ct => ct.configs && ct.configs.wtype === wtypeSelected);
      if (!foundContentType) {
        return facets;
      }

      const contentTypeFacets = getFacets(foundContentType);
      contentTypeFacets.forEach(ct => {
        facets[ct.attribute] = [{
          type: 'value',
          name: ct.label,
          size: 5
        }];
      });

      return facets;
    },
    searchFilters: state => route => {
      const filters = {
        all: [
          { workspace: [store.getters.workspace.code] }
        ],
        any: []
      };

      // folder navigation logic
      if (route.meta && route.meta.folderRoute) {
        let pathSettings = '';

        if (route.params && route.params.pathMatch) {
          pathSettings += route.params.pathMatch;
        }

        if (!pathSettings.startsWith('/')) {
          pathSettings = `/${pathSettings}`;
        }

        filters.all.push({ path: [pathSettings] });

        return filters;
      }

      let activeFilter;

      // TODO add comments
      if (state.search.filters && state.search.filters.length) {
        state.search.filters.map(filter => {
          switch (filter.type) {
            case 'value':
              activeFilter = filters.all.find(f => Object.keys(f)[0] === filter.field);

              if (activeFilter) {
                activeFilter[filter.field].push(filter.value);
              } else if (Array.isArray(filter.value)) {
                filters.all.push({ [filter.field]: filter.value });
              } else {
                filters.all.push({ [filter.field]: [filter.value] });
              }

              break;
          }
        });
      }

      return filters;
    },
    searchRestrictionsFilters: state => {
      const { currentUser } = state;
      const currentWorkspace = store.getters.workspace;
      const currentProject = state.environment.PROJECT;

      const allowContentTypesRestrictions = findRestrictions(currentUser.restrictions, 'show_only_content_types', currentWorkspace.code, currentProject);

      const forbiddenContentTypesRestrictions = findRestrictions(currentUser.restrictions, 'restrict_content_types', currentWorkspace.code, currentProject);

      const searchQuery = { query: { bool: { must: [], must_not: [] } } };

      // create query filter for allowed content types (must)
      if (allowContentTypesRestrictions.length) {
        // must be a single condition
        let wtypes = [];

        allowContentTypesRestrictions.forEach(r => {
          wtypes = [...r.settings.content_types, ...wtypes];
        });

        searchQuery.query.bool.must.push(
          { terms: { wtype: wtypes } }
        );
      }

      // create query filter for forbidden content types (must_not)
      forbiddenContentTypesRestrictions.forEach(r => {
        const filter = { bool: { must: [] } };

        filter.bool.must.push({ terms: { wtype: r.settings.content_types } });

        searchQuery.query.bool.must_not.push(filter);
      });

      // restriction for expecific content (uuid)
      const allowContentsRestrictions = findRestrictions(currentUser.restrictions, 'show_only_contents', currentWorkspace.code, currentProject);
      const forbiddenContentsRestrictions = findRestrictions(currentUser.restrictions, 'hide_contents', currentWorkspace.code, currentProject);

      if (allowContentsRestrictions.length) {
        // must be a single condition
        let uuids = [];

        allowContentsRestrictions.forEach(r => {
          uuids = [...r.settings.limited_contents, ...uuids];
        });

        searchQuery.query.bool.must.push(
          { terms: { 'uuid.raw': uuids } }
        );
      }

      // restriction for a expecific forbidden content
      forbiddenContentsRestrictions.forEach(r => {
        const filter = { bool: { must: [] } };

        filter.bool.must.push({ terms: { 'uuid.raw': r.settings.limited_contents } });

        searchQuery.query.bool.must_not.push(filter);
      });

      return searchQuery;
    },
    getReference: state => reference => state.references[reference],
    permissionToWrite: state => {
      if (state.currentUser.writeWorkspaces.indexOf('*') !== -1 || state.currentUser.writeWorkspaces.includes(store.getters.workspace.code)) {
        return true;
      }

      return false;
    },
    workspaces: state => {
      let workspaces = [];

      // If has full rights on readworkspace or writeWorkspace, it returns all project workspaces
      if (state.currentUser.readWorkspaces.indexOf('*') !== -1 || state.currentUser.writeWorkspaces.indexOf('*') !== -1) {
        workspaces = state.workspaces;
      } else {
        const workspacesFromUser = [...new Set([...state.currentUser.writeWorkspaces, ...state.currentUser.readWorkspaces])];

        // Add readWorkspaces to the list
        workspacesFromUser.map(workspaceCode => {
          // Find workspace object from the list
          const workspace = state.workspaces.find(w => w.code === workspaceCode);
          if (workspace) {
            workspaces.push(workspace);
          }
        });
      }

      // Order workspaces by name
      return _.orderBy(workspaces, [w => w.name.toLowerCase()], ['asc']);
    },
    workspace: state => {
      const validWorkspaces = store.getters.workspaces;

      // If has a workspace selected and is a workspace from the list of valid workspaces
      if (state.workspace) {
        const validWorkspace = validWorkspaces.find(w => w.code === state.workspace.code);
        if (validWorkspace) {
          return validWorkspace;
        }
      }

      // If has a default workspace
      if (state.currentUser.defaultWorkspace) {
        // If is a workspace from the list of valid workspaces
        const defaultWorkspace = validWorkspaces.find(w => w.code === state.currentUser.defaultWorkspace);
        if (defaultWorkspace) {
          return defaultWorkspace;
        }
      }

      // return the first workspace from the valid workspaces list
      return validWorkspaces && validWorkspaces.length ? validWorkspaces[0] : {};
    },
    locale: state => {
      const workspaceSettings = store.getters.workspace.settings;

      if (workspaceSettings && workspaceSettings.languages) {
        if (state.locale && workspaceSettings.languages.allowedLocales.includes(state.locale)) {
          return state.locale;
        }
        state.locale = workspaceSettings.languages.default;
        return workspaceSettings.languages.default;
      }

      state.locale = null;
      return null;
    },
    workspaceWritable: state => {
      // get workspaces with write permissons
      let workspaces = [];

      if (state.currentUser.writeWorkspaces.indexOf('*') !== -1) {
        workspaces = store.getters.workspaces;
      } else {
        store.getters.workspaces.map(workspace => {
          if (state.currentUser.writeWorkspaces.includes(workspace.code)) {
            workspaces.push(workspace);
          }
        });
      }
      // Order workspaces by name
      return _.orderBy(workspaces, [w => w.name.toLowerCase()], ['desc']);
    },
    enviroment: state => {
      if (state.environment && state.environment[process.env.VUE_APP_ENV]) {
        return state.environment[process.env.VUE_APP_ENV];
      }

      return {};
    },
    version: state => {
      // check if exists current version or if this one is in the past
      if (!state.version || new Date(new Date()).setMilliseconds(0) / 1000 > state.version.endValidity) {
        // return first valid version
        const newVersion = store.getters.versions[0];
        Vue.set(state, 'version', newVersion);
        return newVersion;
      }

      // return the version after check if is updated
      return state.version;
    },
    versions: state => {
      // Remove versions outdated
      const versionsFiltered = state.versions.filter(version => new Date(new Date()).setMilliseconds(0) / 1000 < version.endValidity);

      // return all only valid versions
      return versionsFiltered;
    },
    // BUILD A STRING CONTEXT FOR FILTERS
    contexAndAgencyFilters: state => {
      let filterQuery = '';
      state.rules.contextsSelect.map(context => {
        filterQuery += state.rules.contextsSelect[state.rules.contextsSelect.length - 1] === context ? `context:${context}` : `context:${context} OR `;
      });

      if (state.rules.contextsSelect.length === 1 && state.rules.contextsSelect[0] === '302-1-1') {
        filterQuery = 'context:302-1-1 AND agencies:GROUPS';
      }
      return filterQuery;
    },

    ruleContexts: state => {
      const { contexts } = state.references;
      return contexts;
    },

    ruleAgencies: state => {
      const { workspace_agencies } = state.references;

      return workspace_agencies;
    },

    ruleBannerPositions: state => {
      const banner_positions = Object.entries(state.references.banner_positions).map(([key, value]) => ({ value: key, label: value }));

      return banner_positions;
    },
    ruleFacets: state => {
      const facets = Object.entries(state.references.facets).map(([key, value]) => ({ value: key, label: value.label, config: value }));

      return _.orderBy(facets, ['label']);
    },
    rerenderingFacets: state => {
      const facets = Object.entries(state.references.facetsRerenderingAlgolia).map(([key, value]) => ({ value: key, label: value.label, config: value }));

      return _.orderBy(facets, ['label']);
    },
    liveWorkspaces: () => store.getters.workspaces.filter(w => {
      if (w.settings) {
        if (w.settings.archived) {
          return false;
        }
      }
      return true;
    }),
    archivedWorkspaces: () => store.getters.workspaces.filter(w => {
      if (w.settings) {
        if (w.settings.archived) {
          return true;
        }
      }
      return false;
    })
  }
});

export default store;
